import React, { useState, useMemo, useEffect } from 'react';

import {
  Divider,
  Card,
  Row,
  Col,
  // DatePicker,
  notification,
  // Switch,
  // InputNumber,
} from 'antd';
import DF from 'DisplayFramework';
import {
  ExtractPaymentFileParams,
  extractPaymentFileOUT,
} from '../../../services/PaymentServices';
import JobResult from '../../Accounting/Components/JobResult';
import { useQuery } from 'react-query';
// import FormInput from 'components/FormInput';
import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';

import Button from 'components/Button';
import Title from 'components/Title';

// import ThirdPartyInput from 'components/ThirdPartyInput';
// import MGListByUser from 'components/MgListByUser';
// import ParListSelect from 'components/ParListSelect';
import { getMgParValueByParCode } from 'services/parametersService';
import FormInput from 'components/FormInput';
import PFileSelectInput from 'components/PFileSelectInput';
import Value from 'components/Value';
import UtinaCard from 'components/UtinaCard';
// import Value from 'components/Value';

// import ParBankAccountSelect from 'components/ParBankAccountSelect';

const initialSearchParams: ExtractPaymentFileParams = {
  pfid: 0,
  extractionModel: '',
};

const PFileOUTExtract = () => {
  const [form] = useForm();
  const [searchParams, setSearchParams] =
    useState<ExtractPaymentFileParams>(initialSearchParams);

  const loadExtractModel = async () => {
    await getMgParValueByParCode({
      parcode: 'PIEXTMODEL',
    })
      .then((response) => {
        if (response.data != null) {
          form.setFieldsValue({
            extractionModel: response.data.parvaluemin ?? 'UNDEFINED',
          });
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    loadExtractModel();
  });

  const onFinish = (values: ExtractPaymentFileParams) => {
    setSearchParams((prev) => ({
      ...prev,
      ...values,
    }));
    setTimeout(refetch, 0);
  };

  const params = useMemo(
    () => ({
      ...searchParams,
      pfid: form.getFieldValue('pfid'),
      extractionModel: form.getFieldValue('extractionModel') ?? 'UNDEFINED',
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParams]
  );

  const {
    data: jobResponse,
    refetch,
    isFetching,
  } = useQuery(
    ['extractPaymentFileIN', params],
    () =>
      extractPaymentFileOUT(params).then((res) => {
        if (res.code === '200') {
          notification.success({ message: res.message });
        } else {
          notification.error({ message: res.message });
        }
        return res;
      }),
    {
      enabled: false,
    }
  );

  // extractPaymentFile

  return (
    <DF.Provider pagcode="extractpfileout">
      <Card
        title={<Title level={4} comcode="PFileOUTExtract"></Title>}
        size="small"
      >
        <Form
          form={form}
          onFinish={onFinish}
          initialValues={initialSearchParams}
        >
          <Row>
            <Col md={17}>
              <UtinaCard lg={18} comcode="popoulationtotreat" level={5}>
                <Row gutter={30}>
                  <FormInput col xs={24} md={12} name="pfid">
                    <PFileSelectInput paydirection="OUT" />
                  </FormInput>

                  <FormInput col xs={24} md={12} name="extractionModel">
                    <Value />
                  </FormInput>
                </Row>
              </UtinaCard>
            </Col>

            <Col
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                loading={isFetching}
                comcode="runservice"
                type="primary"
                htmlType="submit"
                style={{ width: 200, marginLeft: 15, height: 60 }}
              />
            </Col>
          </Row>
          <Row>
            <Col style={{ alignContent: 'center' }} xs={24}>
              {isFetching && (
                <Title level={3} type="danger" comcode="pleasewait" />
              )}
            </Col>
          </Row>
        </Form>
        <Divider></Divider>
        <br />
        <br />
        <UtinaCard comcode="result" level={5}>
          <JobResult
            jobResponse={jobResponse}
            entity="PAYMENT"
            mode="PAYMENT"
          />
        </UtinaCard>
      </Card>
    </DF.Provider>
  );
};

export default PFileOUTExtract;
